export enum FileType {
  SmallLogo = "SmallLogo",
  LargeLogo = "LargeLogo",
}
